import {Customer} from "@indebted/api"

// resolveCustomerPath returns the deep-link path for a customer: when the customer
// has exactly one account it links straight to that account, otherwise to the
// customer overview. Shared by the simple and advanced search result rows.
function resolveCustomerPath(customer: Customer): string {
	const base = `/customers/${customer.ID}`
	const totalAccounts =
		customer.OutstandingAccounts.length + customer.OtherAccounts.length + customer.PaymentPlanAccounts.length
	if (totalAccounts === 1) {
		if (customer.OutstandingAccounts.length === 1) {
			return `${base}/accounts/outstanding/${customer.OutstandingAccounts[0].ID}`
		}
		if (customer.OtherAccounts.length === 1) {
			return `${base}/accounts/other/${customer.OtherAccounts[0].ID}`
		}
		if (customer.PaymentPlanAccounts.length === 1) {
			return `${base}/accounts/payment-plan/${customer.PaymentPlanAccounts[0].ID}`
		}
	}
	return base
}

export {resolveCustomerPath}
